module.exports = __webpack_public_path__ + "img/bg_btn.4fb44900.png";